import React from 'react';
import LeftDrawer from './LeftDrawer';

const Lk = ({
    logout,
    user,
    currentMenuItem,
}) => {

    return (
        <LeftDrawer
            logout={logout}
            user={user}
            currentMenuItem={currentMenuItem}
        />
    )
}

export default Lk;
